import { Tracking } from './Tracking';
import { ShareableMoments } from '../../SDK/SDKmessages';
import { PayloadType } from '../../SDK/PayloadType';

export default class SocialTracking {
    public static clickInvite() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_RewardedInvite_Show',
        });
    }

    public static switchInvite() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_RewardedInvite_Confirm',
        });
    }

    public static clickCoins() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_Coins_Show',
        });
    }

    public static switchCoins() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_Coins_Confirm',
        });
    }

    public static clickGiftSend() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_GiftSend_Show',
        });
    }

    public static switchGiftSend() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_GiftSend_Confirm',
        });
    }

    public static clickGiftRequest() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_GiftRequest_Show',
        });
    }

    public static switchGiftRequest() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: 'SH_GiftRequest_Confirm',
        });
    }

    public static shareShow(type: ShareableMoments, payload: string) {
        const shareEventName =
            type === ShareableMoments.JACKPOT
                ? 'Share_Show_Jackpot'
                : 'Share_Show_' + payload.charAt(0).toUpperCase() + payload.slice(1);
        Tracking.addTrack({
            eventName: shareEventName,
            valueToSum: 1,
        });
    }

    public static shareConfirm(type: ShareableMoments, payload: string) {
        const shareEventName =
            type === ShareableMoments.JACKPOT
                ? 'Share_Confirm_Jackpot'
                : 'Share_Confirm_' + payload.charAt(0).toUpperCase() + payload.slice(1);
        Tracking.addTrack({
            eventName: shareEventName,
            valueToSum: 1,
        });
    }

    public static joinedFromShare(type: PayloadType, payload: string, newUser: boolean) {
        const userState = newUser ? 'New' : 'Old';
        const shareEventName =
            type === PayloadType.JACKPOT_SHARE
                ? 'Entry_Share' + userState + '_Jackpot'
                : 'Entry_Share' +
                  userState +
                  '_' +
                  payload.charAt(0).toUpperCase() +
                  payload.slice(1);
        Tracking.addTrack({
            eventName: shareEventName,
            valueToSum: 1,
        });
    }
}
